<a class="whatsapp-btn" color="babybeat" button-filled target="_blank" href="https://forms.gle/uv3Bf3iMDzGdPcBs9">
    <i class="fa fa-whatsapp" aria-hidden="true"></i><span>Connect Now</span>
</a>